import { useQuery } from "@tanstack/react-query";
import http_payroll from "../../utils/http_payroll";
import { Api_EndPoints } from "../../utils/Api_EndPoints";

const getAllAcademics = async ({ companyCode }) => {
  const data = await http_payroll.get(
    `${Api_EndPoints.GetAcademics}?CompanyCode=${companyCode}`
  );
  return data;
};

export const useAcademicsQuery = (companyCode) => {
  return useQuery({
    queryKey: [Api_EndPoints.GetAcademics],
    queryFn: () => getAllAcademics(companyCode),
  });
};
